/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Error_Updatesla1Inputs */

const en_cases_settings_error_updatesla1 = /** @type {(inputs: Cases_Settings_Error_Updatesla1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to update the SLA target`)
};

/**
* | output |
* | --- |
* | "Failed to update the SLA target" |
*
* @param {Cases_Settings_Error_Updatesla1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_error_updatesla1 = /** @type {((inputs?: Cases_Settings_Error_Updatesla1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Error_Updatesla1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_error_updatesla1(inputs)
});
export { cases_settings_error_updatesla1 as "cases_settings_error_updateSla" }